export default function getDashStyle(dashstyle?: string): Highcharts.DashStyleValue {
  switch (dashstyle) {
    case "dashed":
      return "ShortDash";
    case "solid":
    default:
      return "Solid";
  }
}
